<template>
    <q-page class=" rounded-borders q-pa-md border" style="height: 100%; overflow-y: auto">

        <!-- DIALOG DE CONFIRMACION DE DELETE -->
        <q-dialog v-model="showDelete" backdrop-filter=" blur(4px) saturate(150%)">
            <q-card class="q-pa-md" style="width: 600px; max-width: 120vw;">
                <q-card-section class="row items-center q-gutter-sm">
                    <q-icon name="warning" color="negative" size="50px" />
                    <q-separator vertical />
                    <div class="q-ml-lg text-h5">Eliminar Paciente</div>
                </q-card-section>
                <q-card-section class="text-grey-7">
                    <p style="font-size:18px">¿Deseas eliminar el paciente <b>{{ itemToDelete.nombres + ' ' +
                        itemToDelete.apellidoPaterno + ' ' + itemToDelete.apellidoMaterno }}</b>?
                        <br />
                        <b>Esta acción no se puede deshacer.</b>
                    </p>
                </q-card-section>
                <q-card-actions class="q-col-gutter-md">
                    <div class="col">
                        <q-btn outline class="full-width" label="Cancelar" color="grey-7" v-close-popup />
                    </div>
                    <div class="col">
                        <q-btn class="full-width" outline label="Eliminar" color="red" @click="deletePaciente" />
                    </div>
                </q-card-actions>
            </q-card>
        </q-dialog>

        <!-- CARD PARA NUEVO PACIENTE -->
        <q-card v-if="showForm" class="q-pa-xl shadow-0 full-height rounded-borders">
            <q-card-section class="q-pa-none q-mb-lg">
                <div class="row items-center justify-between q-col-gutter-md">
                    <div class="col">
                        <div class="text-h6 text-primary">Nuevo Paciente</div>
                        <div class="text-subtitle2 text-grey">
                            Registra los datos generales para poder dar de alta un paciente
                        </div>
                    </div>
                    <div class="col-auto">
                        <q-btn v-if="!showEdit" color="primary" icon="save" label="Guardar Paciente" @click="savePaciente()"
                            class="q-ml-sm" style="min-width: 250px" />
                            <q-btn v-else color="primary" icon="save" label="Actulizar Paciente" @click="editPaciente()"
                            class="q-ml-sm" style="min-width: 250px" />
                        <q-btn color="primary" icon="mdi-magnify" label="Buscar Paciente" @click="mostrarPacientes()"
                            class="q-ml-sm" style="min-width: 250px" />
                    </div>
                </div>
            </q-card-section>
            <q-separator class="q-mb-md bg-primary" />
            <q-card-section class="q-pa-none q-mb-lg">
                <Paciente></Paciente>
            </q-card-section>
        </q-card>

        <!-- CARD PARA VER EL EXPEDIENTE -->
        <q-card v-if="showExpediente" class="q-pa-xl shadow-0   rounded-borders">
            <q-card-section class="q-pa-none q-mb-lg">
                <div class="row items-center justify-between q-col-gutter-md">
                    <div class="col-12">
                        <div class="text-h6 text-primary">Expediente</div>
                        <div class="text-subtitle2 text-grey">
                            En el expediente de cada paciente podras visualizar la información recaudada en cada visita
                        </div>
                    </div>
                    <div class="col-12 row   no-wrap">
                        <q-field filled dense style="width: 100%"    label="Paciente" stack-label>
                                    <template v-slot:control>
                                        <div class="self-center full-width no-outline" tabindex="0">
                                            {{ paciente.nombres + ' ' + paciente.apellidoPaterno + ' ' + paciente.apellidoMaterno }} 
                                        </div>
                                    </template>
                                </q-field>
                        <q-btn color="primary" icon="mdi-format-list-bulleted" label="Lista de Pacientes" @click="mostrarPacientes()"
                            class="q-ml-sm" style="min-width: 250px" />
                    </div>
                </div>
            </q-card-section>
            <q-card-section class="q-pa-none q-mb-lg">
                <Expediente></Expediente>
            </q-card-section>
        </q-card>


        <!-- CARD PARA LISTA DE PACIENTES -->
        <q-card v-if="!showForm && !showExpediente" class="q-pa-xl shadow-0 full-height rounded-borders">
            <q-card-section class="q-pa-none q-mb-lg">
                <div class="row">
                    <div class="col-12">
                        <div class="text-h6 text-primary">Pacientes</div>
                        <div class="text-subtitle2 text-grey">
                            Aquí podrás gestionar la información y detalles de tus pacientes
                        </div>
                    </div>
                    <div class="col-12 row no-wrap justify-end q-mt-md">
                        <q-input filled class="q-mr-sm" dense style="width: 100%" debounce="300" v-model="filtro"
                            placeholder="Buscar">
                            <template v-slot:append>
                                <q-icon name="search" />
                            </template>
                        </q-input>
                        <q-btn color="primary" style="min-width: 200px" icon="refresh" label="Consultar"
                            @click="getPacientes()" />
                        <q-btn color="primary" class="q-ml-sm" style="min-width: 250px" icon="add_circle"
                            label="Nuevo Paciente" @click="nuevoPaciente" />
                    </div>
                </div>
            </q-card-section>

            <q-separator class="q-mb-md bg-primary" />
            <q-table dense bordered class="shadow-0" :rows="pacientes" :loading="loading" :columns="columns"
                color="primary" row-key="_id" :pagination="initialPagination" :filter="filtro">
                <template v-slot:body="props">
                    <q-tr :props="props" class="hover-fila">
                        <q-td key="acciones">
                            <q-btn flat round color="blue" icon="mdi-pencil" @click="editarPaciente(props.row)" />
                            <q-btn flat round color="red" icon="delete" @click="abrirDialogDelete(props.row)" />
                            <q-btn flat round color="purple" icon="mdi-eye" @click="verExpediente(props.row)" />
                        </q-td>
                        <q-td key="nombres" :props="props">{{ props.row.nombres }}</q-td>
                        <q-td key="apellidoPaterno" :props="props">{{ props.row.apellidoPaterno }}</q-td>
                        <q-td key="apellidoMaterno" :props="props">{{ props.row.apellidoMaterno }}</q-td>
                        <q-td key="hospitalProcedencia" :props="props">{{ props.row.hospitalProcedencia }}</q-td>
                        <q-td key="direccion" :props="props">{{ props.row.direccion }}</q-td>
                        <q-td key="telefono" :props="props">{{ props.row.telefono }}</q-td>
                        <q-td key="celular" :props="props">{{ props.row.celular }}</q-td>
                        <q-td key="avisoPrivacidad" :props="props">
                            <q-icon v-if="props.row.avisoPrivacidad == false" color="red" size="32px" name="mdi-alert-circle" />
                            <q-icon v-if="props.row.avisoPrivacidad == true" color="green" size="32px" name="mdi-check-circle" />
                        </q-td>
                    </q-tr>
                </template>
            </q-table>
        </q-card>
    </q-page>
</template>
<script setup>
import { ref } from "vue";
import { useStore } from 'vuex'
import { useRouter } from "vue-router";
import { computed } from 'vue'
import axios from 'axios'
import Paciente from './Paciente.vue'
import Expediente from '../Expediente/Expediente.vue'
import { Notify, useQuasar, QSpinnerFacebook } from 'quasar'
const $q = useQuasar()
const $router = useRouter()
const store = useStore()

const loading = ref(false);
const showForm = ref(false)
const pacientes = ref([]);
const filtro = ref('');

const showDelete = ref(false)
const showEdit = ref(false)
const showExpediente=ref(false);
let itemToDelete = null


const paciente = computed({
    get: () => store.state.pacienteStore,
    set: (val) => store.state.pacienteStore = val
})

const usuario = computed({
    get: () => store.state.usuario,
    set: (val) => store.state.usuario = val
})

const columns = ref([
    { name: 'acciones', label: 'Acciones', field: 'acciones', align: 'center', sortable: true },
    { name: 'nombres', label: 'Nombre(s)', field: 'nombres', align: 'center', sortable: true },
    { name: 'apellidoPaterno', label: 'Apellido Paterno', field: 'apellidoPaterno', align: 'center', sortable: true },
    { name: 'apellidoMaterno', label: 'Apellido Materno', field: 'apellidoMaterno', align: 'center', sortable: true },
    { name: 'hospitalProcedencia', label: 'Hospital de Procedencia', field: 'hospitalProcedencia', align: 'center', sortable: true },
    { name: 'direccion', label: 'Dirección', field: 'direccion', align: 'center', sortable: true },
    { name: 'telefono', label: 'Teléfono', field: 'telefono', align: 'center', sortable: true },
    { name: 'celular', label: 'Celular', field: 'celular', align: 'center', sortable: true },
    { name: 'avisoPrivacidad', label: 'Acepto el Aviso de Privacidad', field: 'avisoPrivacidad', align: 'center' },
]);



const initialPagination = ref({
    sortBy: "nombres",
    descending: false,
    page: 1,
    rowsPerPage: 10,
});

const nuevoPaciente = () => {
    const objeto = {
        nombres: '',
        apellidoPaterno: '',
        apellidoMaterno: '',
        direccion: '',
        telefono: '',
        celular: '',
        diagnostico:'',
        hospitalProcedencia:'',
        creadoPorUsuarioId: usuario.value.id,
    }
    store.state.pacienteStore = { ...objeto }
    showForm.value = true

}

function verExpediente(item) {
    store.state.pacienteStore = item
    showExpediente.value = true
}

const getPacientes = async () => {
    loading.value = true
    try {
        const response = await axios.get('/Pacientes')
        console.log('Respuesta backend:', response.data)
        pacientes.value = response.data
    } catch (error) {
        console.error(error)
        Notify.create({
            message: 'Error al consultar los pacientes',
            color: 'negative',
            position: 'top-right'
        })
    } finally {
        loading.value = false
    }
}

const savePaciente = async () => {
    $q.loading.show({
        spinner: QSpinnerFacebook,
        spinnerColor: 'primary',
        spinnerSize: 100,
        message: 'Guardando paciente...'
    })

    try {
        console.log(paciente)
        const response = await axios.post('Pacientes', paciente.value)
        console.log('Respuesta backend:', response.data)

        Notify.create({
            message: 'Paciente guardado correctamente',
            color: 'positive',
            position: 'top-right'
        })

    } catch (error) {
        console.error('Error al guardar:', error)

        Notify.create({
            message: 'Error al guardar paciente',
            color: 'negative',
            position: 'top-right'
        })
    } finally {
        $q.loading.hide()
        nuevoPaciente();
    }
}

const deletePaciente = async () => {
    $q.loading.show({
        spinner: QSpinnerFacebook,
        spinnerColor: 'primary',
        spinnerSize: 100,
        message: 'Eliminando paciente...'
    })

    try {
        const response = await axios.delete('Pacientes/' + itemToDelete.id)
        console.log(response)

        Notify.create({
            message: 'Paciente eliminado correctamente',
            color: 'positive',
            position: 'top-right'
        })

        getPacientes();
    } catch (error) {
        console.error('Error al eliminar:', error)

        Notify.create({
            message: 'Error al eliminar paciente',
            color: 'negative',
            position: 'top-right'
        })
    } finally {
        $q.loading.hide()
        showDelete.value = false;
    }
}

const editPaciente = async () => {
    $q.loading.show({
        spinner: QSpinnerFacebook,
        spinnerColor: 'primary',
        spinnerSize: 100,
        message: 'Guardando paciente...'
    })

    try {
        console.log(paciente)
        let objeto = {
            direccion : paciente.value.direccion,
            telefono : paciente.value.telefono,
            celular : paciente.value.celular,
            creadoPorUsuarioId : usuario.value.id,
        }
        console.log(objeto  )

        const response = await axios.put('Pacientes/' + paciente.value.id, objeto)
        console.log('Respuesta backend:', response.data)

        Notify.create({
            message: 'Paciente actualizado correctamente',
            color: 'positive',
            position: 'top-right'
        })

    } catch (error) {
        console.error('Error al guardar:', error)
        Notify.create({
            message: 'Error al actulizar paciente',
            color: 'negative',
            position: 'top-right'
        })
    } finally {
        $q.loading.hide()
        nuevoPaciente();
        showEdit.value = false
        showForm.value = false 
    }
}


const abrirDialogDelete = (item) => {
    itemToDelete = item
    showDelete.value = true
}

const mostrarPacientes = () => {
    showForm.value = false
    showEdit.value = false
    showExpediente.value = false
}

const editarPaciente = (item) => {
    store.state.pacienteStore = { ...item }
    showEdit.value = true
    showForm.value = true 
}
</script>